module.exports = __webpack_public_path__ + "img/pearl-river_thumbnail.b50758a7.png";